module.exports = __webpack_public_path__ + "img/7.227144a0.png";